import axios from 'axios'

// Options must stay complete when the API caps each request at 100 records.
export async function fetchAllListPages(url, config = {}) {
  const request = new URL(url, window.location.origin)
  request.searchParams.set('limit', '100')
  const all = []
  let previousPage
  for (let page = 1; ; page += 1) {
    request.searchParams.set('page', String(page))
    const response = await axios.get(request.toString(), {
      ...config,
      params: {...config.params, page: undefined, limit: undefined},
    })
    const body = response.data
    const rows = body.data
    if (!Array.isArray(rows)) throw new Error('รูปแบบข้อมูลรายการไม่ถูกต้อง')
    const fingerprint = JSON.stringify(rows)
    if (rows.length && fingerprint === previousPage) throw new Error('ไม่สามารถโหลดหน้าถัดไปได้ กรุณาลองใหม่')
    previousPage = fingerprint
    if (body.pageInfo?.nextCursor) request.searchParams.set('cursor', body.pageInfo.nextCursor)
    else request.searchParams.delete('cursor')
    all.push(...rows)
    const total = body.total === undefined ? undefined : Number(body.total)
    const totalPage = Number(body.totalPage)
    const perPage = Number(body.perPage || body.limit) || 100
    const hasMore = Number.isFinite(total) ? all.length < total
      : Number.isFinite(totalPage) && totalPage > 0 ? page < totalPage : rows.length >= perPage
    if (!hasMore) return {...response, data: {...body, data: all}}
    if (!rows.length) throw new Error('ข้อมูลรายการเปลี่ยนแปลงระหว่างโหลด กรุณาลองใหม่')
  }
}
